import { Grid, TableCell, TableRow } from "@material-ui/core";
import FormikControl from "@Components/FormikControl/FormikControl";
import React from "react";
import PropTypes, { object } from "prop-types";
import { Formik } from "formik";
import { isObjectEmpty } from "utils";
import ClearIcon from "@material-ui/icons/Clear";
import FilterListIcon from "@material-ui/icons/FilterList";
import { format } from "date-fns";

const TableFilter = ({ filters, setLoading, checkBox }) => {
  let initialValues = {};
  filters.forEach((filter) => {
    if (filter.type === "date") {
      initialValues[filter.apiKey] = new Date();
    } else {
      initialValues[filter.apiKey] = "";
    }
  });
  if (checkBox && filters.length && filters[0].type !== undefined) {
    filters.unshift({});
  }
  const callApi = (values, filter) => {
    let filterValue = {};
    if (!isObjectEmpty(values)) {
      if (filter.apiKey === "display_start_date") {
        filterValue[filter.apiKey] = format(
          values[filter.apiKey],
          "yyyy-MM-dd"
        );
      } else {
        filterValue[filter.apiKey] = values[filter.apiKey];
      }
    }
    filter.apiCall(filterValue, setLoading);
  };
  const handleSelect = (event, formik, filter) => {
    formik.handleChange(event);
    let filterValue = {};
    filterValue[filter.apiKey] = event.target.value;
    filter.apiCall(filterValue, setLoading);
  };
  return (
    <Formik initialValues={initialValues} onSubmit={() => {}}>
      {(formik) => (
        <TableRow>
          {filters.map((filter, key) => {
            let inputField = null;
            switch (filter.type) {
              case "select":
                inputField = (
                  <FormikControl
                    control="select"
                    name={filter.name}
                    options={filter.options}
                    value={formik.values[filter.name]}
                    onChange={(event) => handleSelect(event, formik, filter)}
                    size="small"
                  />
                );
                break;
              case "input":
                inputField = (
                  <FormikControl
                    control="input"
                    name={filter.name}
                    autoComplete="off"
                    options={filter.options}
                    onChange={formik.handleChange}
                    size="small"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        callApi(formik.values, filter);
                      }
                    }}
                  />
                );
                break;
              case "date":
                inputField = (
                  <FormikControl
                    control="datepicker"
                    name={filter.name}
                    autoComplete="off"
                    size="small"
                    helperText={""}
                  />
                );
                break;
              default:
                inputField = null;
            }
            return (
              <TableCell key={key}>
                <Grid container spacing={1} justify="space-between">
                  <Grid item xs={12} sm={12} md={10} lg={10}>
                    {inputField}
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    lg={2}
                    alignContent="center"
                  >
                    {filter.type ? (
                      <Grid item container spacing={1} justify="space-evenly">
                        {filter.type !== "select" ? (
                          <FilterListIcon
                            onClick={() => callApi(formik.values, filter)}
                            style={{ marginBottom: "4px" }}
                          />
                        ) : null}
                        <ClearIcon
                          color="primary"
                          onClick={() => {
                            formik.setFieldValue(filter.name, "");
                            callApi({}, filter);
                          }}
                          style={{ marginBottom: "4px" }}
                        />
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </TableCell>
            );
          })}
        </TableRow>
      )}
    </Formik>
  );
};
TableFilter.propTypes = {
  filters: PropTypes.arrayOf(object),
  setLoading: PropTypes.func,
  checkBox: PropTypes.bool,
};

export default TableFilter;
